"use client";
import { SignIn } from "@clerk/nextjs";

const SigninComp = () => {
  return (
    <div className="flex h-full min-h-screen w-full items-center justify-center">
      <SignIn
        forceRedirectUrl="/autoapply"
        signUpForceRedirectUrl="/onboarding"
      />
    </div>
  );
};

export default SigninComp;
